<template>
    <div>
        <h1 v-if="loggedOut" class="text-center">{{$t('message.logged_out')}}</h1>

        <p class="text-center"><router-link to="/login">{{$t('message.log_in_different_account')}}</router-link></p>
    </div>
</template>

<script>
    import storage, {LOGOUT_REQUEST} from '../_store'

    export default {
        name: 'Logout',
        data () {
            return {
                loggedOut: false
            }
        },
        created () {
            this.$nextTick().then(() => {
                storage.dispatch(LOGOUT_REQUEST).then(() => {
                    this.loggedOut = true
                    this.$router.go('/login')
                })
            })
        }
    }
</script>

<style scoped>

</style>
